/* istanbul ignore next */
export function handleKeyDown(e, callback) {
    if (e.key === "Enter") {
        callback(e);
    }
}
